import { put, takeEvery } from "redux-saga/effects"
import { get, post, getPollsAxiosWithParams } from "helpers/api_helper"
import { getFormDataFromJSON } from "utils"
import { showSavingModal, hideSavingModal } from "../actions"
import {
  updatePlacesFormSuccess,
  updatePlacesFormFailed,
  getPlacesMenuItemSuccess,
  getPlacesMenuItemFailed,
  getSurveySuccess,
  getSurveyFailed,
} from "./actions"
import {
  GET_PLACES_MENU_ITEM,
  GET_SURVEY,
  UPDATE_PLACES_FORM,
} from "./actionTypes"

function* getSurvey({ payload: params }) {
  try {
    const response = yield getPollsAxiosWithParams("/survey", { params })
    yield put(getSurveySuccess(response))
  } catch (error) {
    yield put(getSurveyFailed(error))
  }
}

function* updatePlacesForm({ payload: params }) {
  try {
    yield put(showSavingModal())
    const response = yield post(
      "/admin/places/menu-item",
      getFormDataFromJSON(params)
    )
    yield put(updatePlacesFormSuccess(response))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(updatePlacesFormFailed(error))
  }
}

function* getPlacesMenuItem({ payload: params }) {
  try {
    const response = yield get("/places/menu-item", { params })
    yield put(getPlacesMenuItemSuccess(response))
  } catch (error) {
    yield put(getPlacesMenuItemFailed(error))
  }
}

function* placesSaga() {
  yield takeEvery(GET_SURVEY, getSurvey)
  yield takeEvery(UPDATE_PLACES_FORM, updatePlacesForm)
  yield takeEvery(GET_PLACES_MENU_ITEM, getPlacesMenuItem)
}

export default placesSaga
